// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCdIsvJMhapm7oxFun6EfYZF7Ezqr9IIxM",
  authDomain: "project-one-662e7.firebaseapp.com",
  projectId: "project-one-662e7",
  storageBucket: "project-one-662e7.appspot.com",
  messagingSenderId: "843693816390",
  appId: "1:843693816390:web:de3ce66361d0b6f3f46847",
  measurementId: "G-TPWTR631L7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
